import React from 'react'

const Loylity = () => {
  return (
    <div>Loylity</div>
  )
}

export default Loylity